// dependencies.
import styled from 'styled-components'
// components.
import { Body } from '../Typography'
import { Input } from '../Form'
// utils.
import { useDimensions } from '../../js/hooks'

/************************/
/*                      */
/*    Search Heading    */
/*                      */
/************************/

// partials.
const Wrapper = styled.div({
  display: 'flex',
  flexDirection: (props) => (props.column ? 'column' : 'row'),
  gap: (props) => (props.isTablet ? '8px' : '16px'),
  width: (props) => (props.column ? '100%' : 'fit-content'),
})

// main component.
const FilterAuditedPerson = ({
  label,
  persons,
  onFilter = () => {},
  placeholder = 'Persona auditada',
}) => {
  const { isMobile, isTablet } = useDimensions()

  const optionLabels = persons.map(({ id, name }, i) => ({
    name: id,
    label: name,
  }))

  // ------------------------------------------------------------------------------------------- //
  // CONTENT                                                                                     //
  // ------------------------------------------------------------------------------------------- //
  // return content.
  return (
    <Wrapper column={!!label} isTablet={isTablet}>
      {label && (
        <Body type="caption" color="grey">
          {label}
        </Body>
      )}
      <Input
        isMobile={isMobile}
        options={optionLabels}
        name="status"
        iconL="user"
        placeholder={placeholder}
        onChange={(e) => onFilter(e)}
      />
    </Wrapper>
  )
}

export default FilterAuditedPerson
